import script from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodSelector.vue?vue&type=style&index=0&id=0f16f8e0&lang=css"

const __exports__ = script;

export default __exports__